<template lang="pug">
  v-card(:height="height" :chartHeidht="chartHeidht")
    v-card-text
      div(v-for="(component, index) in components" :key="index")
        u-evolution-chart(
          v-if="component.type === 'evolutionchart' && resultForm && resultForm[component.id]"
          :key='component.key+"-"+index'
          v-model="resultForm[component.id]"
          :component="component"
          :values="resultForm"
          :id='component.id'
          :height="chartHeidht")
</template>

<script>
  import UEvolutionChart from '@/components/charts/EvolutionChart'

  export default {
    name: 'btn-field-charts',

    props: {
      field: {
        type: String,
        required: true
      },
      charts: {
      },
      resultForm: {},
      height: {
        default: 300
      },
      chartHeidht: {
      }
    },

    components: {
      UEvolutionChart
    },

    mounted () {
      // for (let chart of this.charts) {
      //   printChart.render(base.comp, value, 'png')
      // }
    },

    computed: {
      components () {
        return this.charts
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/buttons/FieldCharts.vue